export default "__VITE_ASSET__V$tRxNgJ__"